import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"


import { reactive, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { registerRecordPage, getRegisterDetail } from '@/api/overseasSales/businessRuleSetting'

const __default__ = { name: 'DcCosOFbuRegisterLinksRecord' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  contactInfo: '',
  start: '',
  end: '',
  type: undefined
})
// 获取详情联系人信息
const showMask = (record: any, callBack: (res: any) => void) => {
  getRegisterDetail(record.id).then((res) => {
    const { contactInfo } = res.data
    callBack({ contactInfo })
  })
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await registerRecordPage({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: t('operate.r1nt24'), dataIndex: 'customerName' },
  { title: t('operate.ta0eas'), dataIndex: 'type' },
  {
    title: t('operate.qplb8j'),
    dataIndex: 'contactInfo',
    cosType: 'mask'
  },
  { title: t('operate.pitjjk'), dataIndex: 'operatorName' },
  { title: t('operate.2u7exp'), dataIndex: 'createTime' },
  { title: t('operate.qq3dmf'), dataIndex: 'result' }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosRegisterLinksRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.r1nt24')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.qplb8j')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactInfo,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.contactInfo) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.pitjjk')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.operator,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.operator) = $event)),
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.2u7exp')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.start,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.start) = $event)),
                        endTime: queryForm.end,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.end) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.ta0eas')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        ref: "select",
                        value: queryForm.type,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.type) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('common.all')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('operate.ck63zb')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('operate.4ww2os')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'type')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString([_unref(t)('operate.4ww2os'), _unref(t)('operate.ck63zb')][record.type]), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'result')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString([_unref(t)('operate.jeiacs'), _unref(t)('operate.vw3d2n'), _unref(t)('operate.0lkk5n')][record.result]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})